import React from 'react';
import PropTypes from 'prop-types';
import { buildImagePath } from '../../JobComponents/Company/Image/logo';
import shortid from 'shortid';

import './PressLogoGrid.scss';

const getCompanyFromImagePath = (id) => {
    const idParts = id.split('/');
    const file = idParts[idParts.length - 1];
    const name = file.split('.')[0].replace('_', '-');

    if (!name) return 'press-logo'; // bail with default if problem parsing cloudinary id

    return name;
};

export default class PressLogoGrid extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        logos: PropTypes.arrayOf(
            PropTypes.shape({
                img: PropTypes.string,
                url: PropTypes.string,
            })
        ).isRequired,
    };

    render() {
        const { logos } = this.props;
        const injectedTransform = {
            companyGridImage: 'c_lpad,f_auto,q_auto,w_120,h_50',
        };

        return (
            <div className="component-Layout-PressLogoGrid">
                <div className="image-grid">
                    {logos.map((image, idx) => {
                        const logoOwner = getCompanyFromImagePath(image.img);
                        const logoKey = shortid();
                        const logo =
                            image.url && image.url.length > 0 ? (
                                <a
                                    key={logoKey}
                                    href={image.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`box box-${idx}`}
                                >
                                    <img
                                        alt={logoOwner}
                                        src={buildImagePath(
                                            image.img,
                                            'companyGridImage',
                                            injectedTransform
                                        )}
                                    />
                                </a>
                            ) : (
                                <img
                                    key={logoKey}
                                    alt={logoOwner}
                                    className={`box box-${idx}`}
                                    src={buildImagePath(
                                        image.img,
                                        'companyGridImage',
                                        injectedTransform
                                    )}
                                />
                            );
                        return logo;
                    })}
                </div>
            </div>
        );
    }
}
